// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.input-group.bf-form-error-col input[data-v-3270ecb2],\r\n.input-group.bf-form-error-col textarea[data-v-3270ecb2] {\r\n  border-radius: 4px;\r\n  border: 1px solid #ff2853;\n}\n.input-group.bf-form-error-col label[data-v-3270ecb2] {\r\n  color: #ff2853;\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
